import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function CardCarousalSkeleton() {
  const isMobile = window.innerWidth <= 768;
  const customHeight = isMobile ? 180 : 130; // 👈 mobile pe height barh gayi

  return (
    <div className="d-flex flex-column min-vh-100 gap-4 p-3 align-items-center">
      <div style={{ width: "100%", maxWidth: "800px" }}>
        <Skeleton
          baseColor="#ddd"
          highlightColor="#f5deb3"
          width="100%"
          height={isMobile ? 650 : 300} // 👈 upar wali skeleton bhi mobile pe thoda badi
          style={{ marginTop: 20 }}
        />
      </div>

      <div
        className="d-flex flex-wrap justify-content-center gap-3"
        style={{ width: "100%" }}
      >
        {[...Array(4)].map((_, i) => (
          <Skeleton
            key={i}
            baseColor="#ddd"
            highlightColor="#f5deb3"
            height={customHeight}
            style={{
              marginTop: 20,
              width: window.innerWidth < 576 ? "100%" : 160, // Small screen full width
            }}
          />
        ))}
      </div>
    </div>
  );
}
